import { FC } from "react";

import { useScrollToHashOnFirstRender } from "shared/utils";
import { EditMemberCategories } from "./containers";

export const EditMemberSettingsPage: FC = () => {
  useScrollToHashOnFirstRender();

  return (
    <>
      <EditMemberCategories />
    </>
  );
};
